<template lang="pug">
  v-container
    v-dialog(:fullscreen="isMobile" persistent  :value='createItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        create-item( v-if='createItemDialog' @close="closeDialog()" )
    v-dialog(:fullscreen="isMobile" persistent  :value='purchaseDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      PurchaseForm(v-if='purchaseDialog' @close="closeDialog()")
    v-dialog(:fullscreen="isMobile" persistent  :value='clientsDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      ClientsForm(v-if='clientsDialog' :model="currentClient" @close="closeDialog()")
    v-dialog(:fullscreen="isMobile" persistent  :value='transferDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      TransferForm(v-if='transferDialog' @close="closeDialog()")
    v-dialog(:fullscreen="isMobile" persistent  :value='expensesDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      ExpensesForm(v-if='expensesDialog' :model="currentItemExpenses" @close="closeDialog()")
    v-dialog(persistent  :value='createCategoryDialog'  max-width='500px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        create-category( v-if='createCategoryDialog' @close="closeDialog()")
    v-dialog(:fullscreen="isMobile" persistent  :value='createProviderDialog'  max-width='800px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        create-provider(v-if='createProviderDialog'  @close="closeDialog()" )
    v-dialog(v-model="moreDialog" fullscreen="" hide-overlay="" transition="dialog-bottom-transition")
      v-card.options--background
        v-toolbar(dark="" color="#008f96").elevation-0
          v-btn(icon="" dark="" @click="moreDialog = false")
            v-icon mdi-close
          v-toolbar-title Más opciones
        v-row.options.mt-2
          v-col(v-for="(item, index) in frequentItems" :key="item.id" cols="4" @click="clickedItem(item)").pa-0
            .options__item
              img(:src="item.src").options__item-img
              img(v-if="item.additionalSrc" :src="item.additionalSrc").options__item-img--additional
              span.options__item-title {{item.title}}
    v-bottom-navigation(dark :background-color='color' fixed v-model="bottomNav" shift="")
      v-btn( large icon fab v-for="item in itemsBottomNavContributor" :to="item.to")
        span {{item.name}}
        v-icon {{item.icon}}
      v-btn( large icon fab @click="moreDialog = true")
        span mas
        v-icon mdi-dots-horizontal
</template>

<script>
  import CreateItem from '@/views/custom/CreateProduct'
  import ClientsForm from '@/components/custom/forms/ClientsForm'
  import PurchaseForm from '@/components/custom/forms/PurchaseForm'
  import TransferForm from '@/components/custom/forms/TransferForm'
  import ExpensesForm from '@/components/custom/forms/ExpenseForm'
  import CreateCategory from '@/views/custom/CreateCategory'
  import CreateProvider from '@/views/custom/CreateProvider'

  export default {
    name: 'BottomNav',
    components: {
      CreateItem: CreateItem,
      ClientsForm: ClientsForm,
      PurchaseForm: PurchaseForm,
      TransferForm: TransferForm,
      ExpensesForm: ExpensesForm,
      CreateCategory: CreateCategory,
      CreateProvider: CreateProvider,
    },
    data () {
      return {
        bottomNav: 3,
        createItemDialog: false,
        clientsDialog: false,
        currentClient: '',
        currentItemExpenses: '',
        purchaseDialog: false,
        transferDialog: false,
        createProviderDialog: false,
        createCategoryDialog: false,
        expensesDialog: false,
        moreDialog: false,
        itemsBottomNavContributor: [
          {
            to: '/dashboard/#',
            name: 'Indice',
            icon: 'mdi-home',
            iconActive: require('@/assets/icons/shops.png'),
          },
          {
            to: '/dashboard/products',
            name: 'Inventario',
            icon: 'mdi-format-list-bulleted-square',
            iconActive: require('@/assets/icons/addProduct.png'),
          },
          {
            to: '/dashboard/transactions-list',
            name: 'Facturas',
            icon: 'mdi-text-box-check-outline',
            iconActive: require('@/assets/icons/bills.png'),
          },
          {
            to: '/dashboard/profile',
            name: 'Perfil',
            icon: 'mdi-account-circle',
            iconActive: require('@/assets/icons/tenders.png'),
          },
        ],
        frequentItems: [
          {
            title: 'Crear producto',
            src: require('@/assets/icons/actions/create-product.png'),
            dialogName: 'createProduct',
          },
          {
            title: 'Factura de compra',
            src: require('@/assets/icons/actions/invoice.png'),
            dialogName: 'createPurchase',
          },
          {
            title: 'Realizar traslado',
            src: require('@/assets/icons/actions/transfers.png'),
            dialogName: 'createTransfer',
          },
          {
            title: 'Registrar gastos',
            src: require('@/assets/icons/actions/expenses.png'),
            dialogName: 'createExpenses',
          },
          {
            title: 'Crear Cliente',
            src: require('@/assets/icons/actions/new-client.png'),
            additionalSrc: require('@/assets/icons/actions/add.png'),
            dialogName: 'createClient',
          },
          {
            title: 'Crear Categoria',
            src: require('@/assets/icons/actions/new-category.png'),
            additionalSrc: require('@/assets/icons/actions/add.png'),
            dialogName: 'createCategory',
          },
          {
            title: 'Registrar proveedor',
            src: require('@/assets/icons/actions/provider.png'),
            dialogName: 'createProvider',
          },
          {
            title: 'Crear Tienda',
            src: require('@/assets/icons/actions/new-shop.png'),
            additionalSrc: require('@/assets/icons/actions/add.png'),
            redirect: '/dashboard/create-shop',
          },
          {
            title: 'Colaboradores',
            src: require('@/assets/icons/actions/colaborators.png'),
            redirect: '/dashboard/collaborators',
          },
          {
            title: 'Subir Inventario',
            src: require('@/assets/icons/actions/upload-inventory.png'),
            additionalSrc: require('@/assets/icons/actions/upload.png'),
            redirect: '/dashboard/products/inventory',
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      drawer () {
        return this.$store.state.drawer.drawer
      },
      color () {
        switch (this.bottomNav) {
          // case 0: return 'blue-grey'
          // case 1: return 'teal'
          // case 2: return 'brown'
          // case 3: return 'indigo'
          default: return '#008e95'
        }
      },
      currentDialog () {
        return this.$store.state.dialogs.currentItem
      },
    },
    watch: {
      currentDialog (newVal, oldVal) {
        newVal === 'createProduct' ? this.createItemDialog = true : this.createItemDialog = false
        newVal === 'createPurchase' ? this.purchaseDialog = true : this.purchaseDialog = false
        newVal === 'createTransfer' ? this.transferDialog = true : this.transferDialog = false
        newVal === 'createClient' ? this.clientsDialog = true : this.clientsDialog = false
        newVal === 'createProvider' ? this.createProviderDialog = true : this.createProviderDialog = false
        newVal === 'createExpenses' ? this.expensesDialog = true : this.expensesDialog = false
        newVal === 'createCategory' ? this.createCategoryDialog = true : this.createCategoryDialog = false
      },
    },
    methods: {
      clickedItem (item) {
        if (item.dialogName) {
          this.openDialog(item.dialogName)
        } else {
          this.moreDialog = false
          this.$router.push(item.redirect)
        }
      },
      openDialog (dialog) {
        this.moreDialog = false
        switch (dialog) {
          case 'createProduct':
            this.createItemDialog = true
            break
          case 'createPurchase':
            this.purchaseDialog = true
            break
          case 'createTransfer':
            this.transferDialog = true
            break
          case 'createClient':
            this.createClient()
            this.clientsDialog = true
            break
          case 'createProvider':
            this.createProviderDialog = true
            break
          case 'createExpenses':
            this.createItemExpenses()
            this.expensesDialog = true
            break
          case 'createCategory':
            this.createCategoryDialog = true
            break
        }
        this.$store.dispatch('dialogs/openDialog', dialog).then(function () {
        })
      },
      closeDialog () {
        const vm = this
        vm.$store.dispatch('dialogs/closeDialog').then(function () {
          // dialogs closed
        })
      },
      createItemExpenses () {
        const vm = this
        vm.currentItemExpenses = {
          title: '',
          description: '',
          amount: '',
          type: '',
          location_to: null,
          pictures: {
            imageInput1: '',
          },
        }
        vm.expensesDialog = true
      },
      createClient () {
        const vm = this
        vm.moreDialog = false
        vm.currentClient = {
          name: '',
          identification: '',
          email: '',
          phone: '',
          direction: '',
        }
        vm.clientsDialog = true
      },
      setDrawer (payload) {
        this.$store.dispatch('drawer/set_drawer', payload)
      },
      toggleDrawer () {
        // console.log('entra')
        this.setDrawer(!this.drawer)
      },
      openCreateDialog () {
        const vm = this
        vm.$store.dispatch('dialogs/openCreateDialog').then(function () {

        })
      },
      closeCreateDialog () {
        this.$store.dispatch('dialogs/closeCreateDialog').then(function () {

        })
      },
    },
  }
</script>

<style scoped lang="scss">
  .v-btn--active{
    background: #00CAE3 !important;
  }
  .custom-bottom-nav{
    margin: 0 !important;
    background: #00CAE3;
  }
  .custom-bottom-nav__nav{
    position: fixed !important;
    &__image{
      filter: brightness(0) invert(1);
      height: 50px;
      width: 50px;
      object-fit: contain;
    }
  }

  .options {
    &--background {
      background: #e1e1e1;
    }

    box-sizing: border-box;
    background: #e1e1e1;
    padding: 0 1rem;
    height: 100%;

    &__item {
      // #008f96
      position: relative;
      background: #fff;
      border-radius: 10px;
      height: 9rem;
      margin: 0.5rem;
      padding: 1rem;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

      &-img {
        margin: 0 auto;
        height: 4rem;
        display: block;

        &--additional {
          position: absolute;
          right: 0.2rem;
          top: 0.2rem;
          height: 1.5rem;
        }
      }

      &-title {
        text-align: center;
        display: flex;
        font-weight: 800;
        font-size: 0.8rem;
      }
    }
  }
</style>
